// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__cV36v","title":"styles_title__ePHdk","terms":"styles_terms__GhZx3"};